<div class="CeIntroDialog">
    <h1 class="CeIntroDialog-header">You're heading to ChargEye beta</h1>
    <div class="CeIntroDialog-content">
        <p>
            We're building an entirely new ChargEye. The feature you just clicked on has already moved to the ChargEye
            beta side.
        </p>
        <mat-checkbox [(ngModel)]="doNotShowCheck">Do not show this message again</mat-checkbox>

        <section class="example-section"></section>
    </div>
    <div class="CeIntroDialog-footer">
        <button class="CeIntroDialog-button" (click)="dialogAction(false)">Stay here</button>
        <button class="CeIntroDialog-button CeIntroDialog-button--primary" (click)="dialogAction(true)">
            Continue to ChargEye beta
        </button>
    </div>
</div>
